'use es6';

export function isAuthMocked(options) {
  return Boolean(options.mockAuth);
}